<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title v-if="a != null">
          <div>{{ a.FirstName }} {{ a.LastName }} - {{ $t("labels.Income") }}</div>
        </v-card-title>

        <div style="margin: 1px 5px 5px 15px;">
          <div class="px-3" v-if="a!=null">
            <v-row v-if="a.Incomes.length==0"><v-col
                ><p>{{ $t("labels.IncomeDesc") }}  {{this.empHistoryYears}} {{ $t("labels.IncomeDesc2") }}</p></v-col
              ></v-row
            >

            <v-row>
              <v-col cols="12" v-if="a && a.Incomes.length>0">
                <v-simple-table >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{ $t("labels.Income") }}</th>
                        <th class="text-right" width="150">{{ $t("labels.Amount") }}</th>
                        <th class="text-right" width="150">
                          <span> </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in a.Incomes" :key="item.IncomeID">
                        <td>{{ item.DisplayName }}</td>
                        <td class="text-right">{{ item.DisplayAmount }}</td>
                        <td class="text-right">
                          <v-btn @click="edit(item.IncomeID)" text small color="primary"><v-icon small>fas fa-edit</v-icon></v-btn>
                          <v-btn @click="del(item.IncomeID)" text small color="red"><v-icon small>fas fa-trash-alt</v-icon></v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
             
            </v-row>
          </div>

          <v-card-actions class="mb-5 mt-10">
            <v-btn @click="back" color="grey lighten-1">{{ $t("labels.Back") }}</v-btn>
            <v-spacer />
            <v-btn @click="add" color="primary"><v-icon x-small class="mr-2">fas fa-plus</v-icon>{{$t('labels.AddIncome')}}</v-btn>
            <v-btn :disabled="app.ReqIncome && a.Incomes.length == 0" @click="next" color="primary">{{$t('labels.Next')}}</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>

    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline" v-text="$t('labels.Income')"></span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <small v-html="$t('labels.RequiredFieldsDesc')" />
            <v-row>
              <v-col cols="12">
                <v-select :disabled="disIncomeType" v-model="frm.IncomeTypeDD" :items="incomeTypes" item-text="Label" item-value="Value">
                  <template slot="label">
                    <span v-html="$t('labels.IncomeType')" />
                  </template>
                </v-select> 
              </v-col>
            </v-row>
            <div v-if="frm.IncomeTypeDD == 0 || frm.IncomeTypeDD == 6 || frm.IncomeTypeDD == 11">
              <v-row dense>
                <v-col cols="6">
                  <p_dd menu="EMPLOYMENTHISTORYSTATUS" :label="$t('labels.Status')" v-model="frm.EmploymentHistoryStatusDD" />
                </v-col>               
                <v-col cols="6">
                   <p_money :label="$t('labels.AnnualIncomeAmountR')" v-model="frm.IncomeAmount" />                   
                </v-col>
                 <v-col cols="6">
                  <p_dd menu="EMPLOYMENTHISTORYTYPE" :label="$t('labels.Type')" v-model="frm.EmploymentHistoryTypeDD" />
                </v-col>
                 <v-col cols="12" md="4">
                  <v-text-field :maxlength="50" v-model="frm.JobTitle">
                    <template slot="label"><span v-html="$t('labels.JobTitleR')" /></template>
                  </v-text-field>
                </v-col>
                <!-- <v-col cols="6">
                  <p_dd menu="IncomePeriod" :label="$t('labels.IncomeFrequency')" v-model="frm.IncomePeriodDD">
                    <template slot="label"><span v-html="$t('labels.IncomeFrequency')"/></template>
                  </p_dd>
                </v-col> -->
               
                <v-col v-if="frm.IncomeTypeDD == 6" cols="6">
                  <p_dd dis="true" menu="Occupation" label="Occupation" v-model="frm.OccupationDD" />
                </v-col>
                <v-col v-else cols="6">
                  <p_dd menu="Occupation" label="Occupation" v-model="frm.OccupationDD" />
                </v-col>
                 <v-col v-if="frm.IncomeTypeDD == 6" cols="6" >
                  <p_dd  menu="OperatingAs" label="Operating As" v-model="frm.OperatingAsDD" />
                </v-col>
                <v-col cols="6" >
                  <p_dd menu="IndustrySector" :label="$t('labels.IndustrySector')" v-model="frm.IndustrySectorDD" />
                </v-col>
                <v-col cols="12">
                  <div v-html="$t('labels.TimeAtJobR')" />
                </v-col>

                <v-col cols="3">
                  <v-text-field type="number" :label="$t('labels.Year')" v-model="y" />
                </v-col>
                <v-col cols="3">
                  <v-text-field type="number" :label="$t('labels.Month')" v-model="m" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="frm.EmployerName">
                    <template slot="label"><span v-html="$t('labels.EmployerName')"/></template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <com_phone v-model="frm.EmployerPhoneNumber" :label="$t('labels.EmployerPhoneNumberR')" :masked="false" />
                  <!-- <v-text-field  v-model="frm.EmployerPhoneNumber" v-mask="'(###)###-####'">
                    <template slot="label"><span v-html="$t('labels.EmployerPhoneNumberR')" /></template>
                  </v-text-field> -->
                </v-col>
                <v-col cols="12">
                  <p_addr v-model="frm.Address" :easyModeFlag="true" />
                </v-col>
              </v-row>
            </div>
            <div v-if="frm.IncomeTypeDD != null && frm.IncomeTypeDD != 0 && frm.IncomeTypeDD != 6 && frm.IncomeTypeDD != 11">
              <v-row dense>
                <v-col cols="12" md="4">                  
                  <p_money :label="$t('labels.IncomeAmount')" v-model="frm.IncomeAmount" />
                </v-col>
                <v-col cols="12" md="4">
                  <p_dd menu="IncomePeriod" :label="$t('labels.IncomeFrequency')" v-model="frm.IncomePeriodDD">
                    <template slot="label"><span v-html="$t('labels.IncomeFrequency')"/></template>
                  </p_dd>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="frm.Desc" label="Description" />
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogClose">{{$t('labels.Close')}}</v-btn>
          <v-btn color="blue darken-1" text @click="dialogSave">{{$t('labels.Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawerInviteApplicant";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import p_dd from "@/shared/components/ddSelect";

import p_addr from "@/shared/components/addr";
import p_money from "@/shared/components/money";
import com_phone from "@/shared/components/phone";
export default {
  components: {
    drawer,
    p_dd,
    p_addr
    ,    p_money,
    com_phone
  },
  data() {
    return {
      guid: this.$route.params.guid,
      empHistoryYears: 3,
      disIncomeType:false,
      frm: model.incomeModel(),
      incomeTypes: [],
      dialog: false,
      loadFlag: false,
      app: model.appModel(),
      a: null,
      applicantID: this.$route.params.applicantid,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false,
      y: null,
      m: null
    };
  },
  methods: {
    dialogClose() {
      this.dialog = false;
    },
    dialogSave() {
      if (!this.dialogValid()) return;

      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        Income: this.frm,
        ApplicantID: this.a.ApplicantID
      };
      console.log(postData);
      postData.Income.MonthsAtJob = this.getMonthAtWork();
      dataSvc
        .getHttp()
        .post("/api/MTGAppUpsertIncomeInvite", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) this.loadPage();
        });

      this.dialog = false;
    },
    getMonthAtWork() {
      let monthAtWork = 0;
      if (this.y) monthAtWork = this.y * 12;
      if (this.m) monthAtWork += this.m;
      return monthAtWork;
    },
    dialogValid() {
      if (this.frm.IncomeTypeDD == null) {
        this.$alert(this.$t("Warning"), this.$t("errors.MissingIncomeType"));
        return false;
      }         
      if (this.frm.IncomeTypeDD == 0 || this.frm.IncomeTypeDD == 6 || this.frm.IncomeTypeDD == 11) {
        if (this.frm.EmploymentHistoryStatusDD == null) {
          this.$alert(this.$t("Warning"), this.$t("errors.MissingEmploymentHistoryStatusDD"));
          return false;
        }
        if (this.frm.IncomeAmount == null || this.frm.IncomeAmount <= 0) {
          this.$alert(this.$t("Warning"), this.$t("errors.MissingIncomeAmount"));
          return false;
        } 
        if (this.frm.EmploymentHistoryTypeDD == null) {
          this.$alert(this.$t("Warning"), this.$t("errors.MissingType"));
          return false;
        }
        
      //  if(this.frm.IncomeTypeDD != 0 && this.frm.IncomeTypeDD != 6){
      //       if (this.frm.IncomePeriodDD == null) {
      //         this.$alert(this.$t("Warning"), this.$t("errors.MissingIncomePeriod"));
      //         return false;
      //       }
      //     }
        if( !this.frm.JobTitle){
          this.$alert(this.$t("Warning"), this.$t("errors.MissingEmployerJobTitle"));
                  return false;
        }

        if (this.getMonthAtWork() <= 0) {
          this.$alert(this.$t("Warning"), this.$t("errors.MissingTimeAtWork"));
          return false;
        }

      


        if (!this.frm.EmployerName) {
          this.$alert(this.$t("Warning"), this.$t("errors.MissingEmployerName"));
          return false;
        }
        if (!this.frm.EmployerPhoneNumber) {
          this.$alert(this.$t("Warning"), this.$t("errors.MissingEmployerNumber"));
          return false;
        }
        
      } else {
        if (this.frm.IncomeAmount == null || this.frm.IncomeAmount <= 0) {
          this.$alert(this.$t("Warning"), this.$t("errors.MissingIncomeAmount"));
          return false;
        }
        if(this.frm.IncomeTypeDD != 0 && this.frm.IncomeTypeDD != 6 && this.frm.IncomeTypeDD != 11){
          if (this.frm.IncomePeriodDD < 0 || this.frm.IncomePeriodDD == null) {
            this.$alert(this.$t("Warning"), this.$t("errors.MissingIncomePeriod"));
            return false;
          }
        }
      }
      return true;
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        ApplicantID: this.applicantID,
        MortgageApplicationID: this.mortgageApplicationID,
        guid: this.guid
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoadInvite", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;
             this.empHistoryYears = res.data.EmpHistoryYears;
            for (let i = 0; i < this.app.Applicants.length; i++) {
              if (this.app.Applicants[i].ApplicantID == res.data.CurrentApplicantID) {
                this.a = this.app.Applicants[i];
              }
            }
          }else{
            this.loadFlag = false;
             this.$alert(this.$t('labels.Warning'), this.$t('errors.InviteCoApplicantSubmitted'));
              setTimeout(()=>{
              window.location = '/' + this.siteID ;
              }, 5000);
          }
          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    },
    back() {
      this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/address");
    },
    add() {
      // clear
      this.frm = model.incomeModel();
      this.y = null;
      this.m = null;
      this.dialog = true;
      this.disIncomeType = false;
    },
    del(incomeID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmDeleteIncome"),
        () => {
          let postData = {
            SiteID: this.siteID,
            UserID: this.userID,
            MortgageApplicationID: this.mortgageApplicationID,
            ApplicantID: this.a.ApplicantID,
            IncomeID: incomeID
          };
          this.loadFlag = true;
          dataSvc
            .getHttp()
            .post("/api/MTGAPPDeleteIncomeInvite", postData)
            .then(res => {
              this.loadFlag = false;
              this.loadPage();
            });
        },
        () => {}
      );
    },
    edit(incomeID) {
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.a.ApplicantID,
        IncomeID: incomeID
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoadIncome", postData)
        .then(res => {
          this.frm = res.data.Income;
          this.y = Math.floor(this.frm.MonthsAtJob/12);
          this.m = this.frm.MonthsAtJob % 12;

          this.loadFlag = false;
          this.disIncomeType = true;
          this.dialog = true;
        });
    },
    next() {
      // if there is any employment, need more than 3 years
      if (this.isAnyEmploymentIncome()) {
        //if (this.getTotalEmploymentMonth() < 36)
        if (this.getTotalEmploymentMonth() < (this.empHistoryYears * 12))
        {
        let employmentHistoryErrorMessage;
        if(localStorageSvc.getLanID() == 1) {
          employmentHistoryErrorMessage = this.$t('errors.EmploymentHistoryNeedMoreyears') + this.empHistoryYears + ' years.'
        } else {
          employmentHistoryErrorMessage = this.$t('errors.EmploymentHistoryNeedMoreYearsPart1') +
           this.empHistoryYears + 
           this.$t('errors.EmploymentHistoryNeedMoreYearsPart2') + this.empHistoryYears + ' ans.'
        }
          this.$alert(this.$t("labels.Warning"), employmentHistoryErrorMessage);
          return;
        }
      }
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.a.ApplicantID 
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPDoneIncome", postData)
        .then(res => {
          this.loadFlag = false;
           if(this.app.showProperty == true){
             this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/property");
          }else if(this.app.showAssets == true){
             this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/asset");
          }else{
            this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/summary");
          }
        });
    },
    isAnyEmploymentIncome() {
      for (let i = 0; i < this.a.Incomes.length; i++) {
        if (this.a.Incomes[i].IncomeTypeDD == 0 || this.a.Incomes[i].IncomeTypeDD == 6 || this.a.Incomes[i].IncomeTypeDD == 11) return true;
      }
      return false;
    },
    getTotalEmploymentMonth() {
      let rv = 0;
      for (let i = 0; i < this.a.Incomes.length; i++) {
        if (this.a.Incomes[i].IncomeTypeDD == 0 || this.a.Incomes[i].IncomeTypeDD == 6 || this.a.Incomes[i].IncomeTypeDD == 11) rv += this.a.Incomes[i].MonthsAtJob;
      }
      return rv;
    }
  },
  created() {
     var lan = localStorageSvc.getLanID();
    if(lan == 1){
    this.incomeTypes.push({ Label: "Employment Income", Value: 0 });
    this.incomeTypes.push({ Label: "Self-Employment Income", Value: 6 });
    this.incomeTypes.push({ Label: "Contract Employment Income", Value: 11 });
    this.incomeTypes.push({ Label: "Interest Income", Value: 4 });
    this.incomeTypes.push({ Label: "Child Support", Value: 5 });
    this.incomeTypes.push({ Label: "Pension", Value: 7 });
    this.incomeTypes.push({ Label: "Alimony", Value: 8 });
    this.incomeTypes.push({ Label: "Other", Value: 10 });
    }else{
      this.incomeTypes.push({ Label: "Revenu - emploi", Value: 0 });
    this.incomeTypes.push({ Label: "Revenu - travail indépendant", Value: 6 });
     this.incomeTypes.push({ Label: "Revenu - contrat de travail", Value: 11 });
    this.incomeTypes.push({ Label: "Le revenu d'intérêts", Value: 4 });
    this.incomeTypes.push({ Label: "Pension alimentaire pour enfants", Value: 5 });
    this.incomeTypes.push({ Label: "Pension", Value: 7 });
    this.incomeTypes.push({ Label: "Pension alimentaire pour ex-conjoint(e)", Value: 8 });
    this.incomeTypes.push({ Label: "Autre", Value: 10 });
    }
    

    this.userID = localStorageSvc.getUser();    
    this.loadPage();
    
  },
  beforeRouteUpdate(to, from, next) {
    this.applicantID = to.params.applicantid;
    this.loadPage();
    next();
  },
  watch: {
    "frm.IncomeTypeDD":{
      handler(n){
        if(n != null && n == 6){
          this.frm.OccupationDD = 6;
        }
      }
    },
    "frm.IncomeAmount": {
      handler(n) {
        // try {
        //   let v = Number(n);
        //   if (v < 0) {
        //     this.$nextTick(() => {
        //       this.frm.IncomeAmount = null;
        //     });
        //     return;
        //   } else {
        //     this.$nextTick(() => {
        //       this.frm.IncomeAmount = v;
        //     });
        //   }
        // } catch (err) {
        //   this.$nextTick(() => {
        //     this.frm.IncomeAmount = null;
        //   });
        // }
      },
      deep: false
    },
    y(n) {
      if (n < 0) {
        n = 0;
        this.$nextTick(() => {
          this.y = null;
        });
      }
      this.$nextTick(() => {
        this.y = Number(n);
        if(this.y > 83){
        this.y = 83;
      }
      });
    },
    m(n) {
      if (n < 0) {
        n = 0;
        this.$nextTick(() => {
          this.m = null;
        });
      }
      this.$nextTick(() => {
        this.m = Number(n);
        if(this.m > 3 && this.y == 83){
        this.m = 3;
      }
      let monthAtWork = 0;
      if (this.y) monthAtWork = this.y * 12;
      if (this.m) monthAtWork += this.m;
      if(monthAtWork > 1000){
        this.y = 83;
        this.m = 3;
      }
      });
     
    }
  }
};
</script>

<style></style>
